import {ChangeEventHandler, forwardRef, TextareaHTMLAttributes} from 'react'

import cn from 'classnames/bind'

import s from './Textarea.module.scss'
import ErrorMessage from '../ErrorMessage'
import FieldLabel from '../FieldLabel'
import {IFieldBase} from '../Input/Input'

const cx = cn.bind(s)

export interface ITextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement>, IFieldBase {
	className?: string
	wrapperClassName?: string
	placeholder?: string
	onChange?: ChangeEventHandler<HTMLTextAreaElement> | undefined
}

const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(
	({label, error, isError, wrapperClassName, className, ...props}, forwardedRef) => {
		return (
			<div
				className={cx('wrapper', 'global-textarea-wrapper', wrapperClassName, {
					isError: isError || error,
				})}>
				<div className={cx('inner')}>
					{label ? (
						<FieldLabel label={label} required={props.required}>
							<textarea className={cx('textarea', className)} {...props} ref={forwardedRef} />
						</FieldLabel>
					) : (
						<textarea className={cx('textarea', className)} {...props} ref={forwardedRef} />
					)}
				</div>
				<ErrorMessage error={error} />
			</div>
		)
	},
)

Textarea.displayName = 'Textarea'

export default Textarea
